
<script>
import HtmlParser from "@/components/organisms/cms-container/html-parser";

export default {
  name: "Brands",
  components: { HtmlParser },
  props: {
    pushData: {
      type: Object,
      required: true
    }
  }
};
</script>

<template>
  <div class="c-header-brands">
    <HtmlParser
      context="Menu marques"
      :promo-printing="true"
      :push-data="pushData"
      class="c-header-brands__content"
    />
  </div>
</template>

/* disable scope to apply css style in v-html */
<style scoped  lang="scss">
.c-header-brands {
  border-top: 1px solid #d5d4d4;
  padding: spacing(sm) 0;
  margin: 0 spacing(md);
  :deep(.c-header-brands__content) {
    @import "@/assets/styles/components/header-brands.scss";
  }
}
</style>
